import React from 'react';
import { useSiteMode } from '../../contexts/SiteModeContext';
import { SiteNav } from '../SiteNav';
import { BrandMark } from './BrandMark';
import { FoundingFooter } from './FoundingFooter';
import '../LandingPageV2.css';
import './FoundingMemberPage.css';

const usePublicFounding = () => {
  const { mode, isTester, isAdmin } = useSiteMode();
  return mode === 'founding' && !isTester && !isAdmin;
};

export const PublicNav = (props) => (usePublicFounding() ? (
  <div className="landing-v2 fm-chrome-nav"><header className="lv2-nav"><div className="lv2-nav-inner"><BrandMark /></div></header></div>
) : <SiteNav {...props} />);

export const PublicFooter = ({ fallback = null }) => (usePublicFounding() ? (
  <div className="landing-v2"><FoundingFooter /></div>
) : fallback);
